import { Box, Button, Stack, Typography, useTheme, Zoom } from "@mui/material";
import { SingleProduct } from "../../product/index.js";
import { useMediaQuery } from "../../utilities/index.js";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import Grid from "@mui/material/Unstable_Grid2";
import React from "react";
export const ViewRecommendation = ({ featuredParagraphs, featuredProductId, featuredTitle, products, recommendedProductIds, showPrice, }) => {
    const { t } = useTranslation("c-common");
    const theme = useTheme();
    const isAtleastMd = useMediaQuery(theme.breakpoints.up("md"));
    const isAtleastLg = useMediaQuery(theme.breakpoints.up("lg"));
    const isTouchDevice = useMediaQuery("(hover: none)");
    const router = useRouter();
    const [expanded, setExpanded] = React.useState(false);
    const featuredProduct = products.find(({ id }) => featuredProductId === id) ?? products[0];
    const recommendedProducts = !!recommendedProductIds &&
        products.filter(({ id }) => recommendedProductIds.includes(id)).length === 2
        ? products.filter(({ id }) => recommendedProductIds.includes(id))
        : [products[1], products[2]];
    const initiallyHiddenProducts = products.filter(({ id }) => id !== featuredProduct.id && recommendedProducts.map(({ id }) => id).includes(id) === false);
    const categoryPath = t("slug-print");
    const PADDING = { xs: 1.5, sm: 2.25, lg: 4.5, xl: 5.5 };
    const BORDER_RADIUS = "16px";
    return (React.createElement(Stack, { direction: "column", alignItems: "center", spacing: { xs: 8, lg: 12 } },
        React.createElement(Grid, { container: true, spacing: { xs: 2, lg: 3, xl: 6 }, rowGap: { xs: theme.spacing(2), lg: 0 } },
            React.createElement(Grid, { container: true, xs: 12, sm: 6, lg: 6, spacing: 0, onClick: () => router.push(`/${categoryPath}/${featuredProduct.slug}`), sx: {
                    transition: theme.transitions.create(["box-shadow", "transform", "filter"]),
                    "&:hover": isTouchDevice
                        ? {}
                        : {
                            cursor: "pointer",
                            transform: "scale3d(1.015,1.015,1.015)",
                            filter: "drop-shadow(10px 10px 10px rgba(0, 0, 0, 0.1))",
                            "& > div": {},
                        },
                } },
                React.createElement(Grid, { xs: 6, sx: {
                        background: "white",
                        borderBottomLeftRadius: BORDER_RADIUS,
                        borderTopLeftRadius: BORDER_RADIUS,
                        p: PADDING,
                        zIndex: 10,
                    } },
                    React.createElement(SingleProduct, { hover: false, product: featuredProduct, showPrice: showPrice })),
                React.createElement(Grid, { xs: 6, sx: {
                        background: "white",
                        borderBottomRightRadius: BORDER_RADIUS,
                        borderTopRightRadius: BORDER_RADIUS,
                        hieght: "100%",
                        pl: 2,
                        pr: PADDING,
                        py: PADDING,
                    } },
                    React.createElement(Stack, { direction: "column", alignItems: "center", justifyContent: { xs: "flex-start", lg: "center", xl: "flex-start" }, sx: { height: "100%" } },
                        isAtleastMd && (React.createElement(Typography, { textAlign: "center", variant: isAtleastLg ? "h3" : "h3", sx: { pb: { md: 3, lg: 5 } } }, featuredTitle ?? featuredProduct.title)),
                        !!featuredParagraphs && (React.createElement(React.Fragment, null, featuredParagraphs.map((p, ix) => (React.createElement(Typography, { key: `featured-paragrapg-${ix}`, paragraph: true, sx: { textAlign: "center" }, variant: "body3" }, p))))),
                        !featuredParagraphs && (React.createElement(Typography, { component: "div", sx: { textAlign: "center" }, variant: "body3", dangerouslySetInnerHTML: { __html: featuredProduct.teaser } }))))),
            React.createElement(Grid, { container: true, xs: 12, sm: 6, lg: 6, spacing: 0 }, recommendedProducts.map((product) => (React.createElement(Grid, { xs: 6, sx: { p: PADDING }, key: `recommended-product-${product.slug}` },
                React.createElement(SingleProduct, { product: product, showPrice: showPrice }))))),
            expanded && (React.createElement(React.Fragment, null, initiallyHiddenProducts.map((product) => (React.createElement(Grid, { xs: 3, sx: { p: PADDING }, key: `recommended-product-expanded-${product.slug}` },
                React.createElement(Zoom, { in: expanded },
                    React.createElement(Box, null,
                        React.createElement(SingleProduct, { product: product, showPrice: showPrice }))))))))),
        initiallyHiddenProducts.length > 0 && !expanded && (React.createElement(Button, { variant: "outlined", onClick: () => setExpanded(true) }, t("recommendation-button-show-all-titles", "Alle Krimidinner Spiele anzeigen")))));
};
//# sourceMappingURL=view-recommendation.js.map